import { render, staticRenderFns } from "./AuthorizationsStepsIndexPage.vue?vue&type=template&id=39081b9e&scoped=true&"
import script from "./AuthorizationsStepsIndexPage.vue?vue&type=script&lang=js&"
export * from "./AuthorizationsStepsIndexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39081b9e",
  null
  
)

export default component.exports